module.exports = __webpack_public_path__ + "static/shareFanAir3BG-0b83f556bab24db3ee2d43a31543ee02.png";